import React from 'react'
import PropTypes from 'prop-types'
import { Marker, GoogleApiWrapper} from 'google-maps-react';

const CustomMarker = props =>
<Marker
  key={props.key}
  title={props.title}
  name={props.name}
  icon={{
      url: props.icon,
      anchor: new props.google.maps.Point(32,32),
      scaledSize: new props.google.maps.Size(64,64)
    }}
  onClick={props.onClick}
  position={{lat: props.position.lat, lng: props.position.lat}}
/>


CustomMarker.propTypes = {
  key: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  position: PropTypes.shape({
    lat: PropTypes.string,
    lng: PropTypes.string
  })
}

export default GoogleApiWrapper({
  apiKey: ("AIzaSyA2WpUZSFC101-mkth7Ue7aZJzAlZNUOGs")
})(CustomMarker)



// WEBPACK FOOTER //
// ./src/maps/marker.js